export const componentFactory = (primaryField, field, value, onChange, obj) => {
  return null;
};

export default componentFactory;
